/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import MDBox from "dashboard-template/components/MDBox";
import MDTypography from "dashboard-template/components/MDTypography";
import { ErrorMessage, Field } from "formik";
import { FC, forwardRef } from "react";
import { SelectArrayType } from "types/form.enum";

interface FormSelectInputProps {
  selectArray: SelectArrayType[];
  defaultValue?: string;
  value?: string;
  name: string;
  label: string;
  children?: React.ReactNode;
  fullWidth?: boolean;
  onChange?: (event: SelectChangeEvent<string>) => void;
  readonly?: boolean;
  id?: string;
}

const FormSelectInput = forwardRef(
  (
    { defaultValue, name, label, children, fullWidth, readonly, ...rest }: FormSelectInputProps,
    ref
  ) => {
    return (
      <FormControl variant="standard" fullWidth>
        <InputLabel id="select-label">{label}</InputLabel>
        <Select
         className="FormikSelectInput-select"
          readOnly={readonly}
          labelId="select-label"
          id="select"
          label={label}
          variant="standard"
          defaultValue={defaultValue}
          ref={ref}
          name={name}
          {...rest}
        >
          {children}
        </Select>
        <MDBox className="FormikSelectInput-errorMessage">
          <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
            {(<ErrorMessage name={name} />) as any}
          </MDTypography>
        </MDBox>
      </FormControl>
    );
  }
);

const FormikSelectInput: FC<FormSelectInputProps> = ({ name, selectArray, ...rest }) => {
  return (
    <Field name={name} as={FormSelectInput} {...rest}>
      {selectArray.map((value, index) => (
        <MenuItem key={`${name}Definition${index}`} value={value.value}>
          {value.label}
        </MenuItem>
      ))}
    </Field>
  );
};

export default FormikSelectInput;
